export default {
  'coupon.error_code.E0009': '此票券已逾期',
  'coupon.error_code.E0010': '此票券已全數領取完畢',
  'coupon.error_code.E0011': '您已領過此票券',
  'coupon.error_code.E0012': '這張券已轉贈，快請朋友領取吧',
  'coupon.error_code.E0013': '這張券已過期無法領取',
  'coupon.error_code.E0014': '已超過領券時效',
  'coupon.error_code.E0015': '不好意思! 好友已取消轉券',
  'coupon.error_code.E0016': '此票券異常，領取失敗',
  'coupon.error_code.E0017': '點數不足，無法兌換',
  'coupon.error_code.E0018': '未達發點門檻無法獲得點數',
  'coupon.error_code.E0019': '很抱歉，您的會員等級尚未符合領券資格，感謝您的參與！',
  'coupon.error_code.E0020': '此票券已超過領券期限',
  'coupon.error_code.E0021': '領取優惠點數失敗',
  'coupon.error_code.E0022': '此優惠券將於 {start} 至 {end} 開放領取',
  'coupon.error_code.E0023': '此票券已刪除',
  'coupon.error_code.E0024': '獲得票券失敗',
  'coupon.error_code.default': '獲得票券失敗',
  'coupon.collect.success.coupon': '獲得票券',
  'coupon.collect.success.point': '獲得點數',
} as Record<string, string>;
